import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Edit extends React.Component {

  static contextTypes = {
    modal: PropTypes.object,
    router: PropTypes.object
  }

  static propTypes = {
    form: PropTypes.object
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form {...this._getForm()} />
  }

  _getForm() {
    const { form } = this.props
    return {
      title: 't(Duplicate Form)',
      method: 'POST',
      action: `/api/admin/forms/forms/${form.id}/clone`,
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { label: 't(Title)', name: 'title', type: 'textfield', required: true, defaultValue: `Copy of ${form.title}` },
            { label: 't(URL)', name: 'permalink', type: 'permalinkfield', prefix: '/forms', placeholder: '/path/to/form' }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess(form) {
    this.context.router.push(`/forms/forms/${form.id}`)
    this.context.modal.close()
  }

}

export default Edit
